import {
  mobile,
  backend,
  web,
  javascript,
  html,
  css,
  reactjs,
  redux,
  tailwind,
  git,
  figma,
  starbucks,
  tesla,
  carrent,
  jobit,
  tripguide,
  threejs,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "tech",
    title: "Tech",
  },
];

const services = [
  {
    title: "Web Developer",
    icon: web,
  },
  {
    title: "React Developer",
    icon: mobile,
  },
  {
    title: "Frontend Developer",
    icon: backend,
  },
];

const technologies = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Three JS",
    icon: threejs,
  },
  {
    name: "git",
    icon: git,
  },
  {
    name: "figma",
    icon: figma,
  },
];

const experiences = [
  {
    title: "Frontend Developer Intern",
    company_name: "UX-Prodx",
    icon: starbucks,
    iconBg: "#383E56",
    date: "April 2022 - Sep 2022",
    points: [
      "Utilized HTML5, Bootstrap, and CSS for website development.",
      "Designed mobile-responsive interfaces, resulting in a 20% boost in mobile traffic.",
      "Ensured cross-browser and cross-device compatibility for user interfaces, maintaining a uniform user experience across various platforms."
    ],
  },
  {
    title: "Frontend Developer",
    company_name: "Vspagy(Acadian Technologies Pvt. Ltd.)",
    icon: tesla,
    iconBg: "#E6DEDD",
    date: "OCT 2022 - Present",
    points: [
      "Led the production and ongoing development of over 400 projects.",
      "Gathered requirements from company clients for diverse use cases, discussing functionality needs with the team.",
      "Created engaging user interfaces, resulting in a 30% increase in customer engagement and conversion rates.",
      "Collaborated with APIs to transmit user parameters to the backend, retrieving and displaying results on the user interface with thorough validation checks."
    ],
  },

];

const projects = [
  {
    name: "Kreateapp Website",
    description:
      "Kreate App is a platform that empower you with the essential tools to not only elevate your brand but also drive your success to new heights.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nodejs",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: carrent,
    source_code_link: "https://www.kreateapp.in/",
  },
  {
    name: "Currency Converter",
    description:
      "Explore our React-based currency converter powered by the Converter API. Get real-time exchange rates, intuitive interface, multi-currency support, and responsive design for accurate and seamless currency conversion experiences.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "open source api",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: jobit,
    source_code_link: "https://6623faba67b32000a24ac403--lambent-crisp-3ba321.netlify.app/",
  },
  {
    name: "To Do List(Local Storage",
    description:
      "Efficient To-Do List project in React with Tailwind CSS. Utilizes local storage for data persistence. Seamlessly manage tasks with style and reliability for a productive workflow experience.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "local storage",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: tripguide,
    source_code_link: "https://rad-croquembouche-c27819.netlify.app/",
  },
];

export { services, technologies, experiences, projects };
